import React, { useEffect, useState } from 'react';
import tapIcon from '../../services/TapIcon';
import { connect, useSelector } from 'react-redux';
import Loader from "../../components/ui/Loader/Loader";
import ApplicationLayout from '../../layouts/ApplicationLayout';
import { Helmet } from 'react-helmet';
import HttpAPICall from "../../services/HttpAPICall";
import DatePicker from "react-datepicker";
import { toast } from 'react-toastify';
import CreatableSelect from "react-select/creatable";
import TapIcon from '../../services/TapIcon';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import moment from 'moment';


const ConslidatedTripDetails = (props) => {
    const [imei, setImei] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [loading, setLoading] = useState(false);
    const [conslidatedTripData, setConslidatedTripData] = useState(null);
    const [selectedImei, setSelectedImei] = useState(null);
    const [tripDetails, setTripDetails] = useState(null);
    const [selectedTripRow, setSelectedTripRow] = useState(null);
    const [tripLoading, setTripLoading] = useState(false);
    const [inputDisabled, setInputDisabled] = useState(false);


    const access_token = useSelector(state => state.auth.access_token);

    const [imeiOptions, setImeiOptions] = useState([
        { value: '352592572010858', label: '352592572010858 - Honda City' },
        { value: '353691841172736', label: '353691841172736 - Not Mapped' },
        { value: '353691841180044', label: '353691841180044 - Ofc Genset' },
    ]);
    useEffect(() => {
        const now = new Date();
        const twelveHoursAgo = new Date(now.getTime() - 12 * 60 * 60 * 1000);

        setStartDate(twelveHoursAgo);
        setEndDate(now);
    }, []);
    useEffect(() => {
        if (props.deviceData?.imei_no) {
            const existingOption = imeiOptions.find(option => option.value === props.deviceData?.imei_no);
            if (existingOption) {
                setSelectedImei(existingOption);
                setImei(existingOption.value);
                setInputDisabled(false);
            }
            else {
                setInputDisabled(true);
            }
        }
    }, [props.deviceData?.imei_no, imeiOptions]);
    const selectTapHandle = (selectedOption, fieldName) => {
        if (fieldName === 'imei') {
            setSelectedImei(selectedOption);
            if (selectedOption) {
                setImei(selectedOption.value);
            } else {
                setImei('');
            }
        }
    };
    const handleImeiCreate = (inputText) => {
        const newOption = {
            value: inputText,
            label: `${inputText} `
        };

        setImeiOptions(prev => [...prev, newOption]);
        setSelectedImei(newOption);
        setImei(inputText);

    };
    const fetchTripData = (imei, startDate, endDate) => {
        setTripLoading(true);
        setTripDetails(null);

        const payload = {
            imeIs: [imei.trim()],
            startDate: new Date(startDate).toISOString(),
            endDate: new Date(endDate).toISOString()
        };

        HttpAPICall.withAthorization(
            'POST', `http://tappetbox.mysolutions.in/api/Report/trip-session?closeOpenAtEnd=false`, access_token,
            {}, payload, (resp) => {
                setTripDetails(resp.data);
                toast.success('Trip data fetched successfully');
            },
            () => {
                toast.error('Failed to fetch trip data');
            }
        ).then(() => setTripLoading(false));
    };
    const handleViewTripDetails = (tripRow) => {
        setSelectedTripRow(tripRow);
        fetchTripData(
            tripRow.imei,
            tripRow.startTimestamp,
            tripRow.stopTimestamp
        );
    };

    const fetchConslidatedTripData = (imei, startDate, endDate) => {
        setTripDetails(null)
        setLoading(true);
        setConslidatedTripData(null);

        const requestBody = {
            imeIs: [imei.trim()],
            startDate: new Date(startDate).toISOString(),
            endDate: new Date(endDate).toISOString()
        };

        HttpAPICall.withAthorization('POST', `https://api6.tappetbox.in/api/Report/trip-session/consolidated?closeOpenAtEnd=false`, access_token, {}, requestBody, (resp) => {
            setConslidatedTripData(resp.data);
            toast.success('Device data fetched successfully', { position: toast.POSITION.TOP_RIGHT });
        }, (error) => {
            toast.error('Failed to fetch device data', { position: toast.POSITION.TOP_RIGHT });
        }).then(() => {
            setLoading(false);
        });
    };

    const handleDateTimeChange = (field, value) => {
        if (field === 'startDate') {
            setStartDate(value);
        } else if (field === 'endDate') {
            setEndDate(value);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!selectedImei) {
            toast.error('Please select an IMEI number', { position: toast.POSITION.TOP_RIGHT });
            return;
        }
        if (!startDate || !endDate) {
            toast.error('Please select both start and end dates', { position: toast.POSITION.TOP_RIGHT });
            return;
        }
        fetchConslidatedTripData(imei, startDate, endDate);
    };

    const handleLocationClick = (latitude, longitude) => {
        if (!latitude || !longitude || isNaN(parseFloat(latitude)) || isNaN(parseFloat(longitude))) {
            toast.error('Invalid location coordinates', { position: toast.POSITION.TOP_RIGHT });
            return;
        }

        const mapsUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;
        window.open(mapsUrl, '_blank', 'noopener,noreferrer');
    };

    const formatValue = (key, value, record = null) => {
        if (value === null || value === undefined) return 'N/A';

        if (typeof value === 'boolean') {
            return value ? 'Yes' : 'No';
        }

        if (typeof value === 'number') {
            switch (key) {
                case 'speed':
                    return `${value} km/h`;
                case 'direction':
                    return `${value}°`;
                case 'altitude':
                    return `${value} m`;
                case 'externalVoltage':
                case 'batteryVoltage':
                    return `${value} V`;
                default:
                    return value.toString();
            }
        }

        if ((key.toLowerCase().includes('time') || key.toLowerCase().includes('date')) && !isNaN(Date.parse(value))) {
            return moment(value).format('DD-MMM-YYYY HH:mm:ss');
        }

        if (key.toLowerCase().includes('imei') && record) {
            const hasValidLocation = record.latitude && record.longitude &&
                !isNaN(parseFloat(record.latitude)) && !isNaN(parseFloat(record.longitude));

            if (hasValidLocation) {
                return (
                    <button
                        className="btn btn-link p-0 text-primary text-decoration-none"
                        onClick={() => handleLocationClick(
                            record.latitude,
                            record.longitude,
                        )}
                    >
                        {value}
                    </button>
                );
            }
        }

        return value.toString();
    };

    const renderConslidatedTripData = () => {
        const dataToUse = conslidatedTripData;

        if (!dataToUse) return null;

        if (Array.isArray(dataToUse)) {
            if (dataToUse.length === 0) {
                return (
                    <div className="row mt-4">
                        <div className="col-12">
                            <h6> No data found for the selected criteria.</h6>
                        </div>
                    </div>
                );
            }

            const tripData = dataToUse[0];

            return (
                <div className="row my-4">
                    <div className="col-12">
                        {/* <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5 className="mb-0">Consolidated Trip Details</h5>
                        </div> */}

                        <div className="mb-3 p-3 bg-light rounded">
                            <strong className='me-5'>IMEI Number : </strong>
                            {tripData.imei || 'N/A'}
                        </div>

                        <table className="table table-bordered mb-0 table-hover">
                            <thead className='table-secondary'>
                                <tr>
                                    <th style={{ width: "15%" }}>Parameter</th>
                                    <th style={{ width: "20%" }}>Start</th>
                                    <th style={{ width: "20%" }}>Stop</th>
                                    <th style={{ width: "15%" }}>Total Duration</th>
                                    <th style={{ width: "15%" }}>Total KM Running</th>
                                    <th style={{ width: "15%" }} className='text-center'>Action</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="fw-bold">CL</td>
                                    <td>{tripData.startCL || 'N/A'}</td>
                                    <td>{tripData.closeCL || 'N/A'}</td>
                                    <td rowSpan="5" className="align-middle text-center">

                                        {tripData.totalDuration || 'N/A'}

                                    </td>
                                    <td rowSpan="5" className="align-middle text-center">

                                        {tripData.totalKmRunning ? `${tripData.totalKmRunning} km` : 'N/A'}

                                    </td>
                                    <td rowSpan="5" className="align-middle text-center">
                                        <TapIcon.imageIcon icon={TapIcon.ListActionIcon} alt="action-icon" className="img-fluid px-3" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false" />
                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                            <li>
                                                <button
                                                    className="dropdown-item"
                                                    onClick={() => handleViewTripDetails(tripData)}
                                                >
                                                    View Trip Details
                                                </button>
                                            </li>

                                        </ul>

                                    </td>
                                </tr>

                                <tr>
                                    <td className="fw-bold">Latitude , Longitude</td>
                                    <td>
                                        {tripData.startLat || 'N/A'} , {tripData.startLong || 'N/A'}
                                    </td>
                                    <td>
                                        {tripData.stopLat || 'N/A'},  {tripData.stopLong || 'N/A'}
                                    </td>
                                </tr>

                                <tr>
                                    <td className="fw-bold">Location</td>
                                    <td>
                                        <div className="mb-1">
                                            {tripData?.startLocation ? (
                                                <a href={tripData.startLocation} target="_blank" rel="noopener noreferrer" >
                                                    View Start Map
                                                </a>
                                            ) : 'N/A'}
                                        </div>
                                    </td>
                                    <td>
                                        <div className="mb-1">
                                            {tripData?.stopLocation ? (
                                                <a href={tripData.stopLocation} target="_blank" rel="noopener noreferrer" >
                                                    View Stop Map
                                                </a>
                                            ) : 'N/A'}
                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    <td className="fw-bold">Timestamp</td>
                                    <td>
                                        <div className="mb-1">
                                            {tripData?.startTimestamp ?
                                                moment(tripData.startTimestamp).format('DD-MMM-YYYY HH:mm:ss')
                                                : 'N/A'
                                            }
                                        </div>
                                    </td>
                                    <td>
                                        <div className="mb-1">
                                            {tripData?.stopTimestamp ?
                                              moment(tripData.stopTimestamp).format('DD-MMM-YYYY HH:mm:ss'): 'N/A'
                                            }
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            );
        }

        return (
            <>
                <div className="row mt-4">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header">
                                <h5 className="mb-0">Consolidated Trip Details</h5>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-8 border-end">
                                        <div className="row">
                                            {Object.entries(dataToUse)
                                                .filter(([key]) => key !== 'startLocation' && key !== 'stopLocation')
                                                .map(([key, value]) => (
                                                    <div key={key} className="col-sm-6 mb-2">
                                                        <div className="row">
                                                            <div className="col-6 fw-bold text-end">
                                                                {key}:
                                                            </div>
                                                            <div className="col-6">
                                                                {formatValue(key, value, dataToUse)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div className="d-flex flex-column h-100 justify-content-center">
                                            {dataToUse.startLocation && (
                                                <div className="mb-3 text-center">
                                                    <div className="fw-bold mb-2">Start Location</div>
                                                    <button
                                                        className="btn btn-outline-primary btn-sm"
                                                        onClick={() => {
                                                            const coords = dataToUse.startLocation.split(',');
                                                            if (coords.length === 2) {
                                                                handleLocationClick(coords[0].trim(), coords[1].trim());
                                                            }
                                                        }}
                                                    >
                                                        View Start on Map
                                                    </button>
                                                </div>
                                            )}

                                            {dataToUse.stopLocation && (
                                                <div className="text-center">
                                                    <div className="fw-bold mb-2">Stop Location</div>
                                                    <button
                                                        className="btn btn-outline-danger btn-sm"
                                                        onClick={() => {
                                                            const coords = dataToUse.stopLocation.split(',');
                                                            if (coords.length === 2) {
                                                                handleLocationClick(coords[0].trim(), coords[1].trim());
                                                            }
                                                        }}
                                                    >
                                                        View Stop on Map
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </>
        );
    };

    return (
        <>
            <Helmet><title>Consolidated Running Report </title></Helmet>
            <div className="container-fluid">
                <div className="page_containt row pl2">
                    <div className="pageTbl col-12 pl4">
                        <div className="bg-white p-3">
                            {props?.deviceData?.asset &&
                                <table className="table table-hover table-borderless mt-2">
                                    <tbody>
                                        <tr>
                                            <td className="details-label" style={{ "width": "34%" }}>Asset </td>
                                            <td className="details-name" style={{ "width": "66%" }}>{props?.deviceData?.asset?.asset_name || "-"}({props?.deviceData?.asset?.asset_nickname || "-"})</td>
                                        </tr>
                                        <tr>
                                            <td className="details-label" style={{ "width": "34%" }}> Group</td>
                                            <td className="details-name" style={{ "width": "66%" }}>{props?.deviceData?.group?.group_name || "-"}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            }
                            <form onSubmit={handleSubmit}>
                                <div className="row align-items-center my-3">
                                    <div className="col-sm-4">
                                        <label htmlFor="imei" className="form-label require">IMEI</label>
                                    </div>
                                    <div className="col-sm-4">
                                        <CreatableSelect
                                            required={true}
                                            value={selectedImei}
                                            options={imeiOptions}
                                            onChange={(selectedOption) => selectTapHandle(selectedOption, 'imei')}
                                            onCreateOption={handleImeiCreate}
                                            isClearable={true}
                                            isMulti={false}
                                            isDisabled={props.deviceData?.imei_no || inputDisabled}
                                            placeholder="Please Select IMEI Number"
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    borderColor: '#dee2e6',
                                                    minHeight: '38px'
                                                })
                                            }}
                                        />

                                    </div>
                                </div>

                                <div className="row align-items-center my-3">
                                    <div className="col-sm-4">
                                        <label htmlFor="startDate" className="form-label require">Start Date</label>
                                    </div>
                                    <div className="col-sm-4">
                                        <DatePicker
                                            selected={startDate}
                                            onChange={(value) => handleDateTimeChange('startDate', value)}
                                            dateFormat="dd-MMM-yyyy HH:mm"
                                            className="form-control"
                                            showMonthDropdown
                                            showYearDropdown
                                            showTimeSelect
                                            timeFormat="HH:mm"
                                            timeIntervals={15}
                                            timeCaption="Time"
                                            autoComplete="off"
                                            disabled={inputDisabled}
                                            scrollMonthYearDropdown
                                            required={true}
                                            placeholderText="Please Enter Start Date & Time"
                                        />
                                    </div>
                                </div>

                                <div className="row align-items-center my-3">
                                    <div className="col-sm-4">
                                        <label htmlFor="endDate" className="form-label require">End Date</label>
                                    </div>
                                    <div className="col-sm-4">
                                        <DatePicker
                                            selected={endDate}
                                            onChange={(value) => handleDateTimeChange('endDate', value)}
                                            dateFormat="dd-MMM-yyyy HH:mm"
                                            className="form-control"
                                            showMonthDropdown
                                            showYearDropdown
                                            showTimeSelect
                                            timeFormat="HH:mm"
                                            timeIntervals={15}
                                            timeCaption="Time"
                                            disabled={inputDisabled}
                                            autoComplete="off"
                                            scrollMonthYearDropdown
                                            required={true}
                                            placeholderText="Please Enter End Date & Time"
                                        />
                                    </div>
                                </div>

                                <div className="row align-items-center my-3">
                                    <div className="col-sm-7"></div>
                                    <div className="col-sm-2">
                                        <button
                                            type="submit"
                                            disabled={loading || !selectedImei || inputDisabled}
                                            className="btn btn-primary "
                                        >
                                            GO
                                            {loading && (
                                                <>
                                                    <tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin ms-2" />
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </form>

                            {loading && <Loader />}
                            {inputDisabled && <p className="text-center  mt-3">Not Available</p>}
                            {renderConslidatedTripData()}
                            {tripLoading ? <Loader />
                                :
                                tripDetails && (
                                    <div className="row mt-4">
                                        <div className="col-12">

                                            <div className="tab_content_wrapper"> <span className="content_heading"> Trip Details </span></div>
                                            {tripDetails.length === 0 ? (
                                                <p>No trip details found.</p>
                                            ) : (
                                                <table className="table table-bordered  table-hover mt-4">
                                                    <thead className='table-secondary'>
                                                        <tr>
                                                            <th style={{ width: "25%" }}>Start Time</th>
                                                            <th style={{ width: "25%" }}>End Time</th>
                                                            <th style={{ width: "25%" }}>Total Duration</th>
                                                            <th style={{ width: "25%" }}>Distance (KM)</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {tripDetails.map((trip, index) => (
                                                            <tr key={index}>
                                                                <td>{moment(trip.actualStartTimestamp).format('DD-MMM-YYYY HH:mm:ss')}</td>
                                                                <td>{ moment(trip.actualStopTimestamp).format('DD-MMM-YYYY HH:mm:ss')}</td>
                                                                <td>{trip.totalDuration || 'N/A'}</td>
                                                                <td>{trip.totalKmRunning || 'N/A'}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            )}
                                        </div>
                                    </div>
                                )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ConslidatedTripDetails;